import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Paper from 'components/Paper';
import LinkHeading from 'components/LinkHeading';

const StyledWidgetContainer = styled.div`

  > .card {
    > .section {
      padding: ${({ theme }) => theme.spacing * 2}px;
      &:nth-child(n + 2) {
        border-top: 1px solid ${({ theme }) => theme.palette.grey[4]};
      }
    }
  }

  &.noRoundedCorners{
    > .card {
      border-radius:0;
    }
  }

`;

const WidgetContainer = ({
  title, titleRightElement, className, children, noRoundedCorners,
}) => {
  const classes = ['widgetContainer'];

  if (noRoundedCorners) classes.push('noRoundedCorners');

  if (className) classes.push(className);

  return (
    <StyledWidgetContainer className={classes.join(' ')}>
      {title && <LinkHeading title={title} rightElement={titleRightElement} />}
      <Paper className="card">{children}</Paper>
    </StyledWidgetContainer>
  );
};

export default WidgetContainer;

WidgetContainer.propTypes = {
  title: PropTypes.string,
  titleRightElement: PropTypes.node,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  noRoundedCorners: PropTypes.bool,
};

WidgetContainer.defaultProps = {
  title: null,
  className: null,
  titleRightElement: null,
  noRoundedCorners: false,
};
